import type { Entitlements } from '../types';
import { http } from '@/shared/api/httpClient';

export const billingApi = {
  entitlements: () => http.get<Entitlements>('/tenant/entitlements').then((r) => r.data)
};
